// extracted by mini-css-extract-plugin
module.exports = {"backButton":"backButton__1LqYP","receipt":"receipt__2Z7AP","buttonBox":"buttonBox__3_SLM","shareholderText":"shareholderText__3jjQn"};